import { useEffect, useCallback  } from "react";
import DemoDescription from "./DemoDescription";

export default function SpotlightLayer({
  activeDemo,
  setActiveDemo,
  setFlippingCard
}) {

  const closeSpotlight = useCallback(() => {
        setActiveDemo(null);

        setTimeout(() => {
            setFlippingCard(null);
        }, 300);
    }, [setActiveDemo, setFlippingCard]);

    useEffect(() => {
        function handleKeyDown(e) {
            if (e.key === "Escape") {
            closeSpotlight();
            }
        }

        window.addEventListener("keydown", handleKeyDown);

        return () => {
            window.removeEventListener("keydown", handleKeyDown);
        };
    }, [closeSpotlight]);

  return (
    <div
      className="spotlight-overlay"
      onClick={closeSpotlight}
    >

      <div
        className="spotlight-container"
        onClick={(e) => e.stopPropagation()}
      >

        <button
          className="close-button"
          onClick={closeSpotlight}
        >
          ✕ Back
        </button>

        <div className="spotlight-demo">

          <div className="demo-large">
            {activeDemo.item}

            <DemoDescription demo={activeDemo} />
          </div>

        </div>

      </div>

    </div>
  );
}